export default __webpack_public_path__ + "static/media/welcom2.7b5d8831.jpg";